function isPlanPPO(plan) {
  return plan.coreBenefits.network === 'PPO'
}

export default isPlanPPO
